/**
 * 获取当前请求的 API 基础地址
 * 与 app.tsx 请求拦截器逻辑保持一致：
 * - 开发环境走 /api 代理
 * - 测试环境（scm-test1/2/3）对应 yzapi-test1/2/3.yishou.pro
 * - 其他环境使用构建时配置的 API_URL
 */
export const getApiBaseUrl = (): string => {
  if (process.env.NODE_ENV === 'development') {
    return '/api';
  }
  if (typeof window !== 'undefined') {
    const matched = window.location.hostname.match(/^scm-test(\d+)/);
    if (matched) {
      return `${window.location.protocol}//yzapi-test${matched[1]}.yishou.pro`;
    }
  }
  return API_URL;
};

/** 获取完整 API 地址（开发环境返回完整 URL，用于 WebSocket 等不能使用代理路径的场景） */
export const getApiUrl = (): string => {
  if (process.env.NODE_ENV === 'development') {
    return API_URL;
  }
  return getApiBaseUrl();
};
